
var CartMessage = Backbone.View.extend({
    tagName: 'div',
    className : 'cart-message',
    events: {
        'click a.remove' : 'removeMessage'
    },
    initialize: function(){
        this.template = _.template(document.getElementById('cart-message-template').innerHTML );
        _.bindAll( this, 'render', 'removeMessage', 'removeMessageTimeout' );
        this.render();
    },
    render: function(){
        var output = this.template( this.model.toJSON() );
        this.$el.html( output );
        
        // document.body.append( this.el );

        // this.timeout = setTimeout( this.removeMessageTimeout, 3200 );
    },
    removeMessageTimeout: function( e ){
        if ( typeof e !== 'undefined' ) {
            e.preventDefault();
        }
        // alert( 'Removing');
        clearTimeout( this.timeout );
        this.timeout = setTimeout( this.removeMessage, 1000 );
        this.$el.animate({ opacity: 0.01 }, 1000);
    },
    removeMessage: function( e ){
        if ( typeof e !== 'undefined' ) {
            e.preventDefault();
        }

        // clearTimeout( this.timeout );
        this.model.destroy();
        this.remove();
    }
});
export {CartMessage}